import {enableProdMode} from '@angular/core';
import 'core-js/client/shim.min.js';
import 'zone.js';
import 'reflect-metadata/Reflect.js';
import './polyfills';
import moment from 'moment';
import 'moment-timezone';
import {environment} from './environments/environment';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';

declare global {
    interface Navigator {
        msSaveBlob?: (blob: any, defaultName?: string) => boolean;
    }
}

if (environment.production) {
    enableProdMode();
}

(window as any).m = moment;
(moment as any).tz.setDefault((moment as any).tz.guess());

(window as any).elementHasEllipsis = (element: HTMLElement) => {
    return element.offsetWidth < element.scrollWidth;
};

// platformBrowserDynamic()
//     .bootstrapModule(AppModule)
//     .catch((err) => console.error(err));

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
